; (function ($) {

    let center = [-74.0060,40.7128];
    let zoom = 7;
    let radius = 25;
    let layerIDs = []
    let places = {
        'type': 'FeatureCollection',
        'features': []
    }

    
    if ($(window).width() <= 767) {
        zoom = 6
    }       

    $(window).on('resize', function() {
        if ($(window).width() > 768) {
            zoom = 7
        } else if ($(window).width() <= 768) {
            zoom = 6
        }
    });

	$(document).ready(function(){
        mapboxgl.accessToken = 'pk.eyJ1Ijoic3BlbnNlcmxlaWdodG9uMSIsImEiOiJja2F4aGxnZ2gwNjhvMnFtaGx6a3F5NGNsIn0.bjhGVubMGXUpJapZdcIVdQ';
    
        
        var map = new mapboxgl.Map({
            container: 'stores-map',
            style: "mapbox://styles/spenserleighton1/ck9udi1h9030y1imwoj7gfkbf",
            center: center,
            zoom: zoom
        });   
    
        map.scrollZoom.disable();
    
        const getZipFromLocation = (lat,long) => {
            return fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${long},${lat}.json?access_token=pk.eyJ1Ijoic3BlbnNlcmxlaWdodG9uMSIsImEiOiJja2F4aGxnZ2gwNjhvMnFtaGx6a3F5NGNsIn0.bjhGVubMGXUpJapZdcIVdQ`)
                .then(response => response.json())
                .then(results => {
                    $('.filter-info .zip-num').text(results.features[2].text)
                }
            )
        }
    
        const getLocationFromZip = searchParam => {
            return fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${searchParam} usa.json?access_token=pk.eyJ1Ijoic3BlbnNlcmxlaWdodG9uMSIsImEiOiJja2F4aGxnZ2gwNjhvMnFtaGx6a3F5NGNsIn0.bjhGVubMGXUpJapZdcIVdQ`)
                .then(response => response.json())
                .then(results => {
                    map.flyTo({
                        center: results.features[0].center
                    })
                    updateDistanceFrom(results.features[0].center[1], results.features[0].center[0])
                }
            )
        }
    
        const distance = (lat1, lon1, lat2, lon2, unit) => {
            if ((lat1 == lat2) && (lon1 == lon2)) {
                return 0;
            }
            else {
                var radlat1 = Math.PI * lat1/180;
                var radlat2 = Math.PI * lat2/180;
                var theta = lon1-lon2;
                var radtheta = Math.PI * theta/180;
                var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                if (dist > 1) {
                    dist = 1;
                }
                dist = Math.acos(dist);
                dist = dist * 180/Math.PI;
                dist = dist * 60 * 1.1515;
                if (unit=="K") { dist = dist * 1.609344 }
                if (unit == "N") { dist = dist * 0.8684 }
    
                return dist.toFixed(1);
            }
        }
        
    
    
        $('#filter-toggle').on('click', () => {
            $('.stores-list').toggleClass('filters-active')
        })
    
        $('#open-the-filter').on('click', () => {
            $('.product-select').toggleClass('active')
            $('.map-overlay').toggleClass('active')
        })
       
        $('.radius-filters-container').on('click', () => {
            $('.map-overlay').toggleClass('active')
        })
    
        $(document).on('click', '.map-overlay', function (evt) {    
            if(evt.target.id == "radius-select")
                return;
    
            $('.map-overlay').removeClass('active')
        });
    
        $('#submit-zip').on('click', () => {
            let zipcode = $('#zipcode').val()
            if (zipcode) {
                getLocationFromZip(zipcode)
            }
        })
    
        $('#submit-zip-mobile').on('click', () => {
            let zipcode = $('#zipcode-mobile').val()
            if (zipcode) {
                getLocationFromZip(zipcode)
            }
            updateFilterInfo()
        })
    
        $('#zipcode').bind("enterKey",function(e){
            let zipcode = $('#zipcode').val()
            if (zipcode) {
                getLocationFromZip(zipcode)
            }
    
        });
        
        $('#zipcode').keyup(function(e){
            if(e.keyCode == 13)
            {
                $(this).trigger("enterKey");
            }
        });
    
        const hideCard = (id) => {
           $(`#${id}`).fadeOut('fast')
        }
    
        const showCard = (id) => {
           $(`#${id}`).fadeIn('fast')
        }
    
        const toggleStoreCards = (val,id) => {
            if (val === 'none') {
                hideCard(id)
            } else {
                showCard(id)
            }
        }
    
        const highlightCard = id => {
    
            $('.active').removeClass('active')
            $(`#${id}`).addClass('active')
    
            var target = document.getElementById(id);
            $('.stores-list .row').animate({ scrollTop: target.offsetTop - 196 }, 400);
            if ($(window).width() <= 767) {
                setTimeout(() => {
                    $('.stores-list').removeClass('filters-active')
                }, 666);
            }  
    
        }
    
        const toggleMarker = (radius) => {
            radius = parseInt(radius);
            layerIDs.forEach(function (layerID) {
                let locationDist = parseInt($(`#${layerID}`).data('dist'))
                var value = locationDist < radius ? 'visible' : 'none';
    
                toggleStoreCards(value, layerID)
    
                map.setLayoutProperty(
                    layerID,
                    'visibility',
                    value
                );
            });
        }
    
        const updateFilterInfo = (radius) => {
            setTimeout(() => {     
                // Number of currently displayed stores
                var allStores = document.querySelectorAll('.store-card')
                var nodes = Array.prototype.slice.call(allStores);
                
                let numberOfStores = nodes.filter(function(node) {
                  return node.style.display !== "none"
                }).length
            
                $('.filter-info .store-num').text(numberOfStores);
        
                // Current Center of map
                let center = map.getCenter();
                getZipFromLocation(center.lat, center.lng)
                
                // Radius
                if (radius) {
                    $('.filter-info .miles-num').text(radius);
                }
    
            }, 666);
        }
        
        $('.radius-select li').on('click', function() {
            radius = $(this).data('val');
            let text = $(this).text()
            $('.radius-filter-active span').text(text)
            updateFilterInfo(radius)
            var center = map.getCenter();
            updateDistanceFrom(center.lat, center.lng)
        })

    
        const updateDistanceFrom = (lt, lg) => {
            $('.store-card').each(function (i, card) {
    
                let lat = $(card).data('lat')
                let lng = $(card).data('lng')
                
                let dist = distance(lat, lng, lt, lg);
                $(card).data('dist', dist)
                $(card).children('.card-head').children('.float-right').children('.miles-from').text(`${dist} miles away`)
            })
            setTimeout(() => {
                toggleMarker(radius)
                sortDivs()
            }, 666);
    
        }
    
        const sortDivs = () => {
            var result = $('.store-card').sort(function (a, b) {
                var contentA =$(a).data('dist');
                var contentB =$(b).data('dist');
                return contentA - contentB
             });
          
             $('.stores-list .row:not(.filters)').html(result);
             $('.store-card').on('click', function () {
                 let lat = $(this).data('lat')
                 let lng = $(this).data('lng')
                 let slug = $(this).attr('id')
                 let web = $(this).data('web')
                 let storeName = $(this).children('.card-head').children('.store-title').text();
         

                 
                 highlightCard(slug)
                 map.flyTo({
                     center: [lng, lat]
                 })
         
                 $('.mapboxgl-popup-close-button').click()
                if (web) {
                    perma = `<a target="_blank" href="//${web}"><h5>${storeName}</h5></a>`
                } else {
                    perma = `<h5 class="px-3 my-0">${storeName}</h5>`
                }
                 setTimeout(() => {
                     new mapboxgl.Popup()
                         .setLngLat([lng, lat])
                         .setHTML(perma)
                         .addTo(map);
                 });
             })
        }
    
    
        const addLocationPins = () => {
    
            $('.store-card').each(function (i, card) {
    
                let lat = $(card).data('lat')
                let lng = $(card).data('lng')
                let slug = $(card).attr('id')
                let web = $(card).data('web')
                let storeName = $(card).children('.card-head').children('.store-title').text();
                let dist = distance(lat, lng, 40.7128, -74.0060);
                $(card).data('dist', dist);
                $(card).children('.card-head').children('.float-right').children('.miles-from').text(`${dist} miles away`)
                console.log(`<a href="${web}">${storeName}</a>`)
                let feature = {
                    'type': 'Feature',
                    'properties': {
                        'icon': 'wine',
                        'slug': slug,
                        'storeName': storeName,
                        'web': web
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [lng, lat]
                    },
                    dist
                }
    
                places.features.push(feature)
                
                $(card).on('click', () => {
                    console.log('clicked',web)
                    highlightCard(slug)
                    map.flyTo({
                        center: [lng, lat]
                    })
    
                    $('.mapboxgl-popup-close-button').click()
                    if (web) {
                        perma = `<a target="_blank" href="//${web}"><h5>${storeName}</h5></a>`
                    } else {
                        perma = `<h5 class="px-3 my-0">${storeName}</h5>`
                    }
                    setTimeout(() => {
                        new mapboxgl.Popup()
                            .setLngLat([lng, lat])
                            .setHTML(perma)
                            .addTo(map);
                    });
                })
            })
    
    
    
    
    
    
    
            map.addSource('places', {
                'type': 'geojson',
                'data': places
            });
    
    
            places.features.forEach(function (feature,i) {
    
                var layerID = feature.properties['slug'];
    
                if (!map.getLayer(layerID)) {
                
                    map.addLayer({
                        'id': layerID,
                        'metadata': feature.properties,
                        'type': 'symbol',
                        'source': 'places',
                        'layout': {
                            'icon-image': 'wine',
                            'icon-allow-overlap': false,
                        },
                        'filter': ['==', 'slug', layerID]
                    });
    
                    layerIDs.push(layerID);
    
                    map.on('click', layerID, function (e) {
                        highlightCard(layerID) 
                        var coordinates = e.features[0].geometry.coordinates.slice();
                        var storeName = e.features[0].properties.storeName;
                        var web = e.features[0].properties.web;
                         
                        // Ensure that if the map is zoomed out such that multiple
                        // copies of the feature are visible, the popup appears
                        // over the copy being pointed to.
                        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                        }
                         
                        if (web) {
                            perma = `<a target="_blank" href="//${web}"><h5>${storeName}</h5></a>`
                        } else {
                            perma = `<h5 class="px-3 my-0">${storeName}</h5>`
                        }
                        new mapboxgl.Popup()
                        .setLngLat(coordinates)
                        .setHTML(perma)
                        .addTo(map);
                    });
                         
                    // Change the cursor to a pointer when the mouse is over the places layer.
                    map.on('mouseenter', layerID, function() {
                        map.getCanvas().style.cursor = 'pointer';
                    });
                        
                    // Change it back to a pointer when it leaves.
                    map.on('mouseleave', layerID, function() {
                        map.getCanvas().style.cursor = '';
                    });
    
                }
            });
    
            setTimeout(() => {
                sortDivs()
            });
        }
        
        // getCurrentLocation();
        map.on('load', function (e) {
            addLocationPins();
            toggleMarker(radius)
            updateFilterInfo(radius)
        });
	});

})(jQuery);